import actions from './actions'

export default function PersonalsReducer(state = { loading: false }, action) {
  switch (action.type) {
    case actions.REQUESTING:
      return {
        ...state,
        loading: true,
        editing: null,
        saveSuccess: false,
      }
    case actions.LIST_PERSONAL:
      return {
        ...state,
        result: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.EDIT_PERSONAL:
      return {
        ...state,
        editing: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.RESET_PERSONAL:
      return {
        ...state,
        editing: null,
        loading: false,
        saveSuccess: false,
      }
    case actions.NEW_PERSONAL:
      return {
        ...state,
        editing: { personalID: 0 },
        loading: false,
        saveSuccess: false,
      }
    case actions.CREATE_PERSONAL_RECIEVED ||
      actions.UPDATE_PERSONAL_RECIEVED ||
      actions.DELETE_PERSONAL_RECIEVED:
      return {
        ...state,
        editing: { personalID: 0 },
        loading: false,
        saveSuccess: true, // mark
      }
    case actions.RESPONSE_ERROR:
      return {
        ...state,
        loading: false,
        error: true,
        saveSuccess: false,
        message: action.message,
      }
    default:
      return state
  }
}
